<template>
    <div class="content">
      <div class="block block-rounded block-fx-shadow">
        <div class="block-header block-header-default">
          <h3 class="block-title">Выгрузка</h3>
        </div>
        <div class="block-content">
          <b-tabs content-class="mt-3">
            <b-tab title="Выгрузка Договоров" active v-if="permissions.indexOf('export-debts') != -1">
              <admin-export-debts/>
            </b-tab>
            <b-tab title="Выгрузка платежей" v-if="permissions.indexOf('export-payments') != -1">
              <admin-export-payments/>
            </b-tab>
            <b-tab title="Выгрузка звонков"  v-if="permissions.indexOf('export-calls') != -1">
              <admin-export-calls/>
            </b-tab>
            <b-tab title="Выгрузка контактов">
              <admin-export-contacts/>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  components: {
    AdminExportDebts: () => import('@/components/admin/export/debts.vue'),
    AdminExportPayments: () => import('@/components/admin/export/payments.vue'),
    AdminExportCalls: () => import('@/components/admin/export/calls.vue'),
    AdminExportContacts: () => import('@/components/admin/export/contacts.vue'),
  },
  computed: {
    ...mapGetters([
      'permissions'
    ]),
  },
};
</script>
